import { RequiredTooltipProvider } from '@/shared/components/required-field-tooltip';
import { InspectionStatus } from '@/shared/enums/inspection-status.enum';
import { useReducer } from 'react';
import { useRecordsInspection } from '../../hooks/use-records-inspection.hook';
import { Step2Tab1Overview } from './step-2-tab-1-overview';
import { Step2Tab2Decision } from './step-2-tab-2-decision';

export interface Step2InspectionState {
  step: 'overview' | 'decision';
  decision: null | InspectionStatus;
}

const initialState: Step2InspectionState = {
  step: 'overview',
  decision: null,
};

const reducer = (
  state: Step2InspectionState,
  newState: Partial<Step2InspectionState>
) => ({
  ...state,
  ...newState,
});

interface Step2InspectionProps {
  policyId: string;
  inspectionId: string;
  canWrite: boolean;
  hasWritePermission: boolean;
}

export function Step2Inspection({
  policyId,
  inspectionId,
  canWrite,
  hasWritePermission,
}: Step2InspectionProps) {
  const [state, updateState] = useReducer(reducer, initialState);

  const { data: records } = useRecordsInspection(policyId, inspectionId);

  const latestRecord = records?.[0]?.status as InspectionStatus;

  if (state.step === 'decision') {
    const technicalOpinionFinalized = !!(
      state.decision &&
      [InspectionStatus.UnderReview, InspectionStatus.Dismissed].includes(
        state.decision
      )
    );

    return (
      <RequiredTooltipProvider restartKey={state.step}>
      <Step2Tab2Decision
        policyId={policyId}
        inspectionId={inspectionId}
        isTechnicalOpinionFinalized={technicalOpinionFinalized}
        canWrite={hasWritePermission}
        onCancel={() =>
          updateState({
            step: 'overview',
            decision: null,
          })
        }
      />
      </RequiredTooltipProvider>
    );
  }

  return (
    <RequiredTooltipProvider restartKey={state.step}>
    <Step2Tab1Overview
      policyId={policyId}
      inspectionId={inspectionId}
      onStepChange={updateState}
      canWrite={canWrite}
      hasWritePermission={hasWritePermission}
      latestRecordStatus={latestRecord}
    />
    </RequiredTooltipProvider>
  );
}
